export const getShortID = (id: string) => {
  return id.split('-')[0] || ''
}